// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"4c544647","297":"292a8f08","328":"99e6670a","359":"70453f0f","566":"644600dd","710":"7651c786"}[chunkId] + ".chunk.css";
};